import PayDistribution from "./PayDistribution";

export default PayDistribution;
